import React from 'react';
import Header from './Header.js';
import Footer from './Footer.js';

const Solutions = () => {
  return (
    <div className="solution-page black-bg">
        <div className="position-relative">
            <Header />
            <div className="container padding-top-xxl padding-bottom-xxl">
                <div className="row d-flex justify-content-center align-items-center">
                    <div className="col-md-6 theme-color">
                        <h2>
                            Resolve Sizing Issues 
                            and Enhance Customer Service
                        </h2>
                        <p className="custom-para font-md font-weight-extra-light padding-right-xxl padding-top-sm">
                            Achieve the perfect fit with a seamless, <br/>
                            one-time scan, enhancing precision and efficiency for your business
                        </p>
                    </div>
                    <div className="col-md-6 ">
                        <img src="images/solution-img.png" className="img-fluid d-block mx-auto" alt="Meas-Sol" />
                    </div>
                </div>
            </div>
        </div>

        <section className="integration-container">
            <div className="container-fluid">
                <div className="row d-flex justify-content-center align-items-center padding-top-xl padding-bottom-xl">
                    <div className="col-md-6 p-0">
                        <img src="images/macbook.png" className="img-fluid" alt="Meas-Sol" />
                    </div>
                    <div className="col-md-6 theme-color padding-left-xl">
                        <h2>Convenient Integration</h2>
                        <p className="custom-para font-md font-weight-extra-light padding-right-xxl">
                            Our solution streamlines sizing with accuracy and efficiency, 
                            reducing errors and saving time. Easy to implement, 
                            it helps businesses cut costs and improve operations without disruption.
                        </p>

                        <div className="padding-top-xl">
                            <ul className="custom-para font-md font-weight-extra-light">
                                <li>Seamless Setup</li>
                                <li>Instant Accuracy</li>
                                <li>Scalable Solution</li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        <Footer />
    </div>
  );
}

export default Solutions;